<lpx-navbar-routes
  [navbarItems]="decorateItems(navbarItems)"
  [groupedItems]="decorateGroupedItems(groupItems)"
  [routerItem]="true"
></lpx-navbar-routes>

<ng-template #facultyManagementTemplate let-item>
  <span class="lpx-menu-item-text hidden-in-hover-trigger">
    <ng-container *ngIf="isAbpLocalizationKey(item?.text); else lpxTranslate">
      {{ item?.text | abpLocalization }}
    </ng-container>
    <ng-template #lpxTranslate>
      {{ item?.text | lpxTranslate | async }}
    </ng-template>
  </span>

  <ng-container *ngIf="pendingCount$ | async as count">
    <span *ngIf="count > 0" class="badge rounded-pill bg-danger ms-2">{{ count }}</span>
  </ng-container>
</ng-template>
